import React from 'react';

import { Box, Skeleton, Stack, Typography } from '@mui/material';

type DashboardOverviewListItemProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  number?: string;
  loading?: boolean;
};

export const DashboardOverviewBlockListItem: React.FC<DashboardOverviewListItemProps> = ({
  title,
  subtitle,
  number,
  loading,
}) => {
  const titleContent = loading ? <TitleSkeleton /> : title;
  const subtitleContent = loading ? <SubtitleSkeleton /> : subtitle;
  const numberContent = loading ? <NumberSkeleton /> : number;

  return (
    <Stack direction="row">
      <Stack>
        <Typography variant="subtitle2">{titleContent}</Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitleContent}
        </Typography>
      </Stack>
      <Box sx={{ ml: 'auto', fontSize: 24, fontWeight: 500 }}>{numberContent}</Box>
    </Stack>
  );
};

const TitleSkeleton: React.FC = () => <Skeleton variant="text" width={200} />;
const SubtitleSkeleton: React.FC = () => <Skeleton variant="text" width={166} />;
const NumberSkeleton: React.FC = () => <Skeleton variant="rounded" width={28} height={30} />;
